import Vue from 'vue'
import axios from 'axios'
import store from '../store'
import { showLimitDialog } from '@/components/limitDialog'
const http = axios.create()
http.defaults.timeout = 10000
http.defaults.baseURL = process.env.VUE_APP_BASE_URL
http.interceptors.request.use(function (config) {
  // 登录 office 后每次请求会携带 token做登录认证使用

  config.headers[process.env.VUE_APP_TOKEN] = 'liebao'
  if (store.getters.token) {
    if (!config.data) {
      config.data = {}
    }
    config.data.common = {
      uid: store.getters.uid,
      token: store.getters.token
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// 添加响应拦截器
http.interceptors.response.use(function (response) {
  const data = response.data || response
  // eslint-disable-next-line camelcase
  const { resp_common } = data
  if (resp_common.ret !== 0) {
    // 当天下载次数超额
    if (resp_common.ret === 50032) {
      showLimitDialog()
    }
    return Promise.reject(new Error(resp_common.msg))
  }
  return Promise.resolve(data)
}, function (error) {
  if (!error.response) {
    // store.commit('logout')
    return Promise.reject(error)
  }
  const response = error.response.data
  return Promise.reject(response)
})

export default http
